import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

const CONTENT_MAX_WIDTH = 1280;

export const breadcrumbBar = css`
  background-color: ${colors.neutral.background.default};

  nav {
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    li > a,
    li > span {
      ${applyFont(typography.mini)}
    }
  }
`;

export const wrapper = css`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH}px;
  padding: ${spacing.s} ${spacing.s};
  margin: 0 auto;
`;
